import { apiClient } from '@shared/api/client'
import type {
  AiReadingHistoryItem,
  AiReadingRequest,
  AiReadingStatusResponse,
  AiReadingSubmitResponse,
  FollowUpHistoryItem,
  FollowUpRequest,
  FollowUpResponse,
  ReadingSection,
} from '../model/types'

export const sajuApi = {
  /** AI reading — 비동기 요청 (hashKey 반환) */
  aiReadingSubmit: (sajuType: string, body: AiReadingRequest, characterId?: number) =>
    apiClient
      .post<AiReadingSubmitResponse>(`/v1/front/saju/${sajuType}/ai-reading`, body, {
        params: characterId ? { characterId } : undefined,
      })
      .then((res) => res.data),

  /** AI reading — 결과 폴링 (sections 미지정 시 전체 반환) */
  aiReadingStatus: (sajuType: string, hashKey: string, sections?: ReadingSection[]) =>
    apiClient
      .get<AiReadingStatusResponse>(`/v1/front/saju/${sajuType}/ai-reading/${hashKey}`, {
        params: sections?.length ? { sections: sections.join(',') } : undefined,
      })
      .then((res) => res.data),

  /** 분석 내역 목록 조회 */
  readingHistory: (sajuType: string) =>
    apiClient
      .get<AiReadingHistoryItem[]>(`/v1/front/saju/${sajuType}/ai-reading/history`)
      .then((res) => res.data),

  /** 후속 질문 전송 */
  followUp: (sajuType: string, hashKey: string, body: FollowUpRequest) =>
    apiClient
      .post<FollowUpResponse>(`/v1/front/saju/${sajuType}/ai-reading/${hashKey}/follow-up`, body)
      .then((res) => res.data),

  /** 후속 질문 대화 이력 조회 */
  followUpHistory: (sajuType: string, hashKey: string) =>
    apiClient
      .get<FollowUpHistoryItem[]>(`/v1/front/saju/${sajuType}/ai-reading/${hashKey}/follow-up`)
      .then((res) => res.data),
}
